/* global _satellite kWidget */

let kdp = null;
document.addEventListener('DOMContentLoaded', () => {
    const videoWrapper = document.querySelectorAll('#kaltura-video');
    if (videoWrapper.length === 0) return;

    videoWrapper.forEach((item) => {
        const openButton = item.querySelector('.kaltura-thumb-play');
        const playButton = item.parentElement.querySelector('#kantura-play-button');
        const videoPlayer = item.querySelector('#kaltura_player');

        if (item.classList.contains('video--modal')) {
            const dialog = item.querySelector('#video_dialog');
            const dialogInner = item.querySelector('#video_dialog_inner');

            if (playButton) {
                playButton.addEventListener('click', () => {
                    dialog.showModal();
                    dialog.focus();
                    document.documentElement.classList.add('no-scroll');
                    document.body.classList.add('no-scroll');
                });
            }

            item.addEventListener('click', () => {
                dialog.showModal();
                dialog.focus();
                document.documentElement.classList.add('no-scroll');
                document.body.classList.add('no-scroll');
            });

            dialog.addEventListener('click', () => {
                dialog.close();
            });

            dialogInner.addEventListener('click', (e) => {
                e.stopPropagation();
            });

            dialog.addEventListener('close', () => {
                document.body.classList.remove('no-scroll');
                document.documentElement.classList.remove('no-scroll');
            });
        } else {
            if (playButton) {
                playButton.addEventListener('click', () => {
                    item.classList.add('kaltura-video-visible');
                    videoPlayer.classList.remove('hidden');
                    openButton.style.zIndex = '-1';
                    kdp.sendNotification('doPlay');
                });
            }
            item.addEventListener('click', () => {
                item.classList.add('kaltura-video-visible');
                videoPlayer.classList.remove('hidden');
                openButton.style.zIndex = '-1';
                kdp.sendNotification('doPlay');
            });
        }
    });
});

kWidget.embed({
    targetId: 'kaltura_player',
    wid: '_2912111',
    uiconf_id: '46471823',
    cache_st: 1234,
    entry_id: '1_dxf725bi',
    flashvars: {
        autoPlay: false,
        'EmbedPlayer.ShowOriginalPoster': true,
    },

    // Ready callback is issued for this player:
    readyCallback: function (playerId) {
        //console.log( "kWidget player ready: " + playerId );
        //var kdp = $( '#' + playerId ).get(0);

        kdp = document.getElementById(playerId);
        //console.log('Entry/Video name: '+ kdp.evaluate('{mediaProxy.entry.name}') );
        //var KentryName = kdp.evaluate('{mediaProxy.entry.name}');

        kdp.kBind('mediaReady', function () {
            // get the video name after media has loaded
            var KentryName = kdp.evaluate('{mediaProxy.entry.name}');

            kdp.kBind('firstPlay.fp', function () {
                // Adobe Analytics code below
                _satellite.track('videofirstplay', {
                    videoName: KentryName,
                });
                console.log('Entry/Video name: ' + KentryName);
                console.log('first play');
                //
                kdp.kUnbind('.fp');
            });
            kdp.kBind('firstQuartile.1q', function () {
                // Adobe Analytics code below
                _satellite.track('videofirstQuartile', {
                    videoName: KentryName,
                    percentPlayed: '25',
                });
                console.log('first quartile');
                //
                kdp.kUnbind('.1q');
            });
            kdp.kBind('secondQuartile.2q', function () {
                // Adobe Analytics code below
                _satellite.track('videosecondQuartile', {
                    videoName: KentryName,
                    percentPlayed: '50',
                });
                console.log('second quartile');
                //
                kdp.kUnbind('.2q');
            });
            kdp.kBind('thirdQuartile.3q', function () {
                // Adobe Analytics code below
                _satellite.track('videothirdQuartile', {
                    videoName: KentryName,
                    percentPlayed: '75',
                });
                console.log('third quartile');
                //
                kdp.kUnbind('.3q');
            });
            kdp.kBind('playerPlayEnd.pe', function () {
                // Adobe Analytics code below
                _satellite.track('videoplayerEnd', {
                    videoName: KentryName,
                });
                console.log('play ended');
                kdp.kUnbind('.pe');
            });
            kdp.kBind('mediaError.me', function () {
                // Adobe Analytics code below
                _satellite.track('videoError', {
                    videoName: KentryName,
                });
                console.log('video error');
                kdp.kUnbind('.me');
            });
            kdp.kBind('mute.mu', function () {
                // Adobe Analytics code below
                _satellite.track('videoMutechange', {
                    videoName: KentryName,
                });
                console.log('muted');
                kdp.kUnbind('.mu');
            });
            kdp.kBind('unmute.um', function () {
                // Adobe Analytics code below
                _satellite.track('videoMutechange', {
                    videoName: KentryName,
                });
                console.log('unmuted');
                kdp.kUnbind('.um');
            });
        });

        // $('.kaltura-thumb-play').on('click', function () {
        //     $('#kaltura_player').removeClass('hidden');
        //     $('.kaltura-thumb-play').css('z-index', '-1');
        //     kdp.sendNotification('doPlay');
        // });
    },
});

kWidget.embed({
    targetId: 'kaltura_player2',
    wid: '_2912111',
    uiconf_id: '46471823',
    cache_st: 1234,
    entry_id: '1_dxf725bi',
    flashvars: {
        autoPlay: false,
        'EmbedPlayer.ShowOriginalPoster': true,
    },

    // Ready callback is issued for this player:
    readyCallback: function (playerId) {
        //console.log( "kWidget player ready: " + playerId );
        //var kdp = $( '#' + playerId ).get(0);

        let kdp2 = document.getElementById(playerId);
        //console.log('Entry/Video name: '+ kdp2.evaluate('{mediaProxy.entry.name}') );
        //var KentryName = kdp2.evaluate('{mediaProxy.entry.name}');

        kdp2.kBind('mediaReady', function () {
            // get the video name after media has loaded
            var KentryName = kdp2.evaluate('{mediaProxy.entry.name}');

            kdp2.kBind('firstPlay.fp', function () {
                // Adobe Analytics code below
                _satellite.track('videofirstplay', {
                    videoName: KentryName,
                });
                console.log('Entry/Video name: ' + KentryName);
                console.log('first play');
                //
                kdp2.kUnbind('.fp');
            });
            kdp2.kBind('firstQuartile.1q', function () {
                // Adobe Analytics code below
                _satellite.track('videofirstQuartile', {
                    videoName: KentryName,
                    percentPlayed: '25',
                });
                console.log('first quartile');
                //
                kdp2.kUnbind('.1q');
            });
            kdp2.kBind('secondQuartile.2q', function () {
                // Adobe Analytics code below
                _satellite.track('videosecondQuartile', {
                    videoName: KentryName,
                    percentPlayed: '50',
                });
                console.log('second quartile');
                //
                kdp2.kUnbind('.2q');
            });
            kdp2.kBind('thirdQuartile.3q', function () {
                // Adobe Analytics code below
                _satellite.track('videothirdQuartile', {
                    videoName: KentryName,
                    percentPlayed: '75',
                });
                console.log('third quartile');
                //
                kdp2.kUnbind('.3q');
            });
            kdp2.kBind('playerPlayEnd.pe', function () {
                // Adobe Analytics code below
                _satellite.track('videoplayerEnd', {
                    videoName: KentryName,
                });
                console.log('play ended');
                kdp2.kUnbind('.pe');
            });
            kdp2.kBind('mediaError.me', function () {
                // Adobe Analytics code below
                _satellite.track('videoError', {
                    videoName: KentryName,
                });
                console.log('video error');
                kdp2.kUnbind('.me');
            });
            kdp2.kBind('mute.mu', function () {
                // Adobe Analytics code below
                _satellite.track('videoMutechange', {
                    videoName: KentryName,
                });
                console.log('muted');
                kdp2.kUnbind('.mu');
            });
            kdp2.kBind('unmute.um', function () {
                // Adobe Analytics code below
                _satellite.track('videoMutechange', {
                    videoName: KentryName,
                });
                console.log('unmuted');
                kdp2.kUnbind('.um');
            });
        });

        // $('.kaltura-thumb-play').on('click', function () {
        //     $('#kaltura_player').removeClass('hidden');
        //     $('.kaltura-thumb-play').css('z-index', '-1');
        //     kdp.sendNotification('doPlay');
        // });
    },
});
